<template>
  <div class="flex overflow-x-auto md:flex-wrap">
    <label
      v-for="option in options"
      :key="option"
      :class="{ 'bg-gray-400': isSelected(option), 'bg-white': !isSelected(option) }"
      class="mr-1 mb-2 leading-none rounded py-2 px-3 cursor-pointer shadow-md"
    >
      <span>{{ option }}</span>
      <input
        v-model="selected"
        :value="option"
        type="checkbox"
        class="hidden"
      />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      required: true,
      type: Array
    },
    value: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  watch: {
    selected: function (oldSelected, newSelected) {
      this.$emit('selection', this.selected)
    }
  },
  data () {
    return {
      selected: this.value
    }
  },
  methods: {
    isSelected (option) {
      return this.selected.find(o => o === option)
    }
  }
}
</script>
